import React, { useEffect } from 'react'
import { Link } from 'react-router-dom';

import flatpickr from 'flatpickr';
import 'flatpickr/dist/flatpickr.min.css';
import CodeBox from '../../CodeBox';

const Flatpickrc = () => {
  useEffect(() => {
    // Initialize Flatpickr
    const basicPicker = flatpickr('.f-basic', {
      enableTime: true,
      dateFormat: 'Y-m-d H:i',
    });

    const dateDisablePicker = flatpickr('.f-date-disable', {
      disable: ['2023-04-24', '2023-05-17', '2025-03-08', new Date(2025, 4, 9)],
      dateFormat: 'Y-m-d',
    });

    return () => {
      // Destroy Flatpickr instances when the component unmounts
      basicPicker.destroy();
      // hfdPicker.destroy();
      dateDisablePicker.destroy();
    };
  }, []); // Empty dependency array to run this effect only once

  const flatpickrCode = `
    import flatpickr from 'flatpickr';
    import 'flatpickr/dist/flatpickr.min.css';

    const basicPicker = flatpickr('.f-basic', {
        enableTime: true,
        dateFormat: 'Y-m-d H:i',
    });

    return (
    	<input type="text" className="form-control f-basic flatpickr-input"
        placeholder="Select Date.." readOnly="readOnly"/>
    )
  `;

  return (
    <div>
      {/* // x---------------------------------x Flatpickr Page Section x---------------------------------x */}
      <div className="row">
        <div className="col-md-12">
          <div className='card h-100'>
            <div className="rounded-4 mb-3 mb-sm-0 bg-white">
              <div className="card-body">
                <div className="px-xl-5 px-lg-4 px-3 py-3 page-body bg-card">
                  <h4 className="mb-4">Flatpickr</h4>
                  <p className="lead">
                    flatpickr is a lightweight and powerful datetime picker. Demos
                    and documentation:
                    <Link to="https://flatpickr.js.org" rel="nofollow" target="_blank">https://flatpickr.js.org</Link>
                  </p>
                  <div className="row g-xl-4 g-3 mb-4">
                    <div className="col-12">
                      <CodeBox code={flatpickrCode} auto={true} />
                    </div>
                    <div className="col-12">
                      <label className="form-label">flatpickr without any
                        config</label>
                      <input type="text" className="form-control f-basic flatpickr-input" placeholder="Select Date.." readOnly="readOnly" />
                    </div>
                    <div className="col-12">
                      <h5>Human-friendly Dates</h5>
                      <p>altInput hides your original input and creates a new one.
                      </p>
                      <p>Upon date selection, the original input will contain a
                        Y-m-d... string, while the altInput will display the
                        date in a more legible, customizable format.</p>
                      <p className="mb-4">Enabling this option is highly recommended.
                      </p>
                      <label className="form-label">flatpickr without any
                        config</label>
                      <input type="hidden" className="form-control f-hfd flatpickr-input" placeholder="Select Date.." readOnly="readOnly" /><input className="form-control f-hfd flatpickr-input form-control input" placeholder="Select Date.." tabIndex="0" type="text" readOnly="readOnly" />
                    </div>
                    <div className="col-12">
                      <h5>Disabling dates</h5>
                      <p>If you’d like to make certain dates unavailable for
                        selection, there are multiple methods of doing so.</p>
                      <ul>
                        <li>Disabling specific date</li>
                        <li>Disabling a date range</li>
                        <li>Disabling dates using a function</li>
                      </ul>
                      <p className="mb-5">All of those are possible with the disable
                        option</p>
                      <label className="form-label">flatpickr without any
                        config</label>
                      <input type="text" className="form-control f-date-disable flatpickr-input" placeholder="Select Date.." readOnly="readOnly" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Flatpickrc